import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'scrollingelement';
import 'transitionEnd';
import 'index.scss';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import Loader from '@livongo/ui/Loader';
import APIUtils from '@livongo/utils/api';
import NewRelicUtils from '@livongo/utilities/system/newrelic';
import createStore from 'store';
import Root from 'app/Root';
import Arg from '@livongo/arg';
import i18n from 'i18n';

const DEBUG = process.env.DEBUG === 'true';
const isDev = process.env.NODE_ENV === 'development';
let domain = window.location.hostname;
const parts = domain.split('.');

// Update New Relic key values for this repository
const nrObject = {
    ACCOUNT_ID: window?.process?.env?.ACCOUNT_ID ?? process.env.ACCOUNT_ID,
    TRUST_KEY: window?.process?.env?.TRUST_KEY ?? process.env.TRUST_KEY,
    AGENT_ID: window?.process?.env?.AGENT_ID ?? process.env.AGENT_ID,
    LICENSE_KEY: window?.process?.env?.LICENSE_KEY ?? process.env.LICENSE_KEY,
    APPLICATION_ID:
        window?.process?.env?.APPLICATION_ID ?? process.env.APPLICATION_ID,
};

// Initialize New Relic
NewRelicUtils.init({document, nrObject});

if (parts.length > 2) {
    domain = parts.slice(parts.length - 2).join('.');
}

const accessToken = Arg('authToken');

document.cookie = `access_token=${accessToken}; Domain=${domain}; Path=/; Secure; SameSite=None`;

if (isDev) {
    const axe = require('react-axe');
    const ReactDOM = require('react-dom');

    axe(React, ReactDOM, 1000);
}

render(<Loader />, document.querySelector('.root'));

APIUtils.init({
    baseUrl: window?.process?.env?.API_URL ?? process.env.API_URL,
    additionalHeaders: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Arg('authToken')}`,
    },
});

function renderRoot(initialState = {}) {
    render(
        <Provider store={createStore(initialState)}>
            <Root />
        </Provider>,
        document.querySelector('.root')
    );
}

let lang = Arg('locale');

if (lang !== 'en-US') {
    // default to english
    lang = 'en';
}

i18n({isDev, debug: DEBUG, lang});

renderRoot();
